import { callApi, HTTPMethods } from '@/utils/api';
import KeycloakService from './keycloakService';
import { getApiUrl } from '@/utils/url';
import type { SocialLinkResponse } from '@/types/api';

export default {
  /** GET /social-links → SocialLinkResponse[]. Pass language for localized resource (fr fallback if missing). */
  async getSocialLinks(language?: string): Promise<SocialLinkResponse[]> {
    await KeycloakService.CallUpdate();
    const config = {
      'Content-Type': 'application/json',
    };
    const qs = language ? `?language=${encodeURIComponent(language.slice(0, 2))}` : '';
    return new Promise((resolve, reject) => {
      callApi({
        path: `${getApiUrl()}/social-links${qs}`,
        method: HTTPMethods.GET,
        options: config,
        successCallback: (result: SocialLinkResponse[]) => resolve(result),
        errorCallback: reject,
      }).catch(reject);
    });
  },
};
